module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/logo@3x-828fb962661dfcb007a7995386a38b3d.png";